import { getSessionStore } from "app/utils/sessionStore";
import {
  createGradient,
  getThemeColors,
  getUSANumberFormat,
  projectionSDOptions,
  formatToCompactNumber,
} from "app/utils/utils";
import { Chart } from "primereact/chart";
import IPPageNumber from "../IPPageNuber";
import HexagonImg from "../../images/hexagonImg.png";
import { lineChartOptions } from "app/uicomponents/macrocomponents/PlansSummary/config";
import { getColorVariations } from "app/utils/colorUtils";

const projectionsTableHeaders = [
  { header: "Policy Year", color: "#3a7cb8" },
  { header: "Insured Age", color: "#336392" },
  { header: "Estimated Income", color: "#2e547d" },
  { header: "Illustrated Plan Accumulated Value", color: "#244161" },
  { header: "Illustrated Plan Surrender Value", color: "#162c46" },
  { header: "Illustrated Plan DB", color: "#162c46" },
];

const loanTableHeaders = [
  { header: "Policy Year" },
  { header: "Insured Age" },
  { header: "Plan Financing Rate" },
  { header: "Minimum AFR" },
  { header: "Plan Interest" },
  { header: "Minimum AFR Interest" },
  { header: "Imputed Compensation To EMPLOYEE" },
  { header: "EOY Outstanding Financing Balance" },
];

const SDIPProjections = ({
  graphData,
  isNewPage = false,
  pageNumber,
  tableData,
}: {
  graphData?: any;
  isNewPage?: boolean;
  pageNumber: string | number;
  tableData?: any;
}) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { primaryColor, ipTooltipColor, secondaryColor } = getThemeColors(branding);

  const planYear = graphData?.map((item: any) => item.planYear);
  // const currentYear = new Date().getFullYear();

  const deathBenefit = graphData?.map((item: any) => item.deathBenefit);

  // const totalDeathBenefit = deathBenefit?.reduce((acc: any, value: any) => acc + value, 0);
  const currentYearDeathBenefit = graphData?.[9]?.deathBenefit || 0;
  // graphData?.find((item: any) => item.year === currentYear)?.deathBenefit || 0;

  const cashBenefit = graphData?.map((item: any) => item.cashValue);
  // const totalCash = cashBenefit?.reduce((acc: any, value: any) => acc + value, 0);
  const currentYearCash = graphData?.[9]?.cashValue || 0;

  const incomeData = graphData?.map((item: any) => item.income);
  // const totalIncome = incomeData?.reduce((acc: any, value: any) => acc + value, 0);
  const currentYearIncome = graphData?.[9]?.income || 0;

  const accountData = graphData?.map((item: any) => item.accountValue);
  // const totalAccountValue = accountData?.reduce((acc: any, value: any) => acc + value, 0);
  const currentYearAccountValue = graphData?.[9]?.accountValue || 0;

  const loanData = graphData?.map((item: any) => item.loan);
  // const totalLoan = loanData?.reduce((acc: any, value: any) => acc + value, 0);
  const currentYearLoan = graphData?.[9]?.loan || 0;

  const incomeChart = {
    labels: planYear?.slice(0, 10),
    datasets: [
      {
        label: "Income",
        fill: true,
        borderColor: projectionSDOptions(primaryColor)[0].indicatorColor,
        backgroundColor: projectionSDOptions(primaryColor)[0].indicatorColor,
        yAxisID: "y",
        tension: 0.4,
        data: incomeData,
        borderRadius: {
          topLeft: 8,
          topRight: 8,
        },
      },
    ],
  };

  const accountValueChart = {
    labels: planYear?.slice(0, 10),
    datasets: [
      {
        label: "Account Value",
        fill: true,
        borderColor: projectionSDOptions(primaryColor)[1].indicatorColor,
        backgroundColor: (context: any) =>
          createGradient(context, projectionSDOptions(primaryColor)[1].indicatorColor),
        yAxisID: "y",
        tension: 0.4,
        data: accountData,
      },
    ],
  };

  const cashValueChart = {
    labels: planYear?.slice(0, 10),
    datasets: [
      {
        label: "Surrender Value",
        fill: true,
        borderColor: projectionSDOptions(primaryColor)[2].indicatorColor,
        backgroundColor: (context: any) =>
          createGradient(context, projectionSDOptions(primaryColor)[2].indicatorColor),
        yAxisID: "y",
        tension: 0.4,
        data: cashBenefit,
      },
    ],
  };

  const deathBenefitChart = {
    labels: planYear?.slice(0, 10),
    datasets: [
      {
        label: "Death Benefit",
        fill: true,
        borderColor: projectionSDOptions(primaryColor)[3].indicatorColor,
        backgroundColor: (context: any) =>
          createGradient(context, projectionSDOptions(primaryColor)[3].indicatorColor),
        yAxisID: "y",
        tension: 0.4,
        data: deathBenefit,
      },
    ],
  };

  const loanChart = {
    labels: planYear?.slice(0, 10),
    datasets: [
      {
        label: "Financing",
        fill: true,
        borderColor: projectionSDOptions(primaryColor)[4].indicatorColor,
        backgroundColor: (context: any) =>
          createGradient(context, projectionSDOptions(primaryColor)[4].indicatorColor),
        yAxisID: "y",
        tension: 0.4,
        data: loanData,
      },
    ],
  };

  const getVariationColorLoan = getColorVariations(secondaryColor, loanTableHeaders.length);
  const variationColorLoan = getVariationColorLoan.reverse();

  const getVariationColorProjections = getColorVariations(
    secondaryColor,
    projectionsTableHeaders.length,
  );
  const variationColorProjections = getVariationColorProjections.reverse();

  const renderContent = () => {
    if (isNewPage && pageNumber === 6) {
      return (
        <div className="flex flex-col items-center justify-center h-full">
          <div className="w-full mb-5 bg-white">
            <div className="flex justify-between conthrax-font" style={{ width: "503px" }}>
              <p className="font-bold text-gray-800 text-sm">Surrender Value</p>
              <div className="text-base font-bold text-gray-500">
                ${formatToCompactNumber(currentYearCash)}
              </div>
            </div>
            <Chart
              type="line"
              height="250px"
              width="503px"
              data={cashValueChart}
              options={lineChartOptions(false, ipTooltipColor, "Plan Year", "Plan Year")}
            />
          </div>
          <div className="w-full bg-white">
            <div className="flex justify-between conthrax-font" style={{ width: "503px" }}>
              <p className="font-bold text-gray-800 text-sm">Death Benefit</p>
              <div className="text-base font-bold text-gray-500">
                ${formatToCompactNumber(currentYearDeathBenefit)}
              </div>
            </div>
            <Chart
              type="line"
              height="250px"
              width="503px"
              data={deathBenefitChart}
              options={lineChartOptions(false, ipTooltipColor, "Plan Year", "Plan Year")}
            />
          </div>
        </div>
      );
    }
    if (isNewPage && pageNumber === 8) {
      return (
        <div>
          <div className="w-full mb-2 bg-white">
            <div className="flex justify-between" style={{ width: "503px" }}>
              <p className="font-bold text-gray-800 text-sm conthrax-font">Financing</p>
              <div className="text-base font-bold text-gray-500 conthrax-font">
                ${formatToCompactNumber(Math.floor(currentYearLoan))}
              </div>
            </div>
            <Chart
              type="line"
              height="200px"
              width="503px"
              data={loanChart}
              options={lineChartOptions(false, "#808080", "Plan Year", "Plan Year")}
            />
          </div>
          <table className="w-full border-collapse bg-white">
            <thead>
              <tr>
                {loanTableHeaders.map((item, index) => (
                  <th
                    key={item.header}
                    style={{ backgroundColor: variationColorLoan[index] }}
                    className="p-1 text-center font-semibold text-white pdf_table_border border-white"
                  >
                    {item.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((item: any, index: any) => (
                <tr
                  key={index}
                  style={{ backgroundColor: "#EEEEEE", color: "#000000", fontSize: "10px" }}
                >
                  <td className="p-1 text-center pdf_table_border border-white">
                    {item.policyYear}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    {item.insuredAge}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    {item.planLoanRate || 0}%
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    {item.minimumAFR || 0}%
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(item.planInterest, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(item.minimumAFRInterest, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(item.imputedCompensationToEmployee, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(item.eoyOutstandingLoanBalance, false)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    if (isNewPage && pageNumber === 7) {
      return (
        <table className="w-full border-collapse bg-white">
          <thead>
            <tr>
              {projectionsTableHeaders.map((item, index) => (
                <th
                  key={item.header}
                  style={{ backgroundColor: variationColorProjections[index] }}
                  className="p-1 text-center font-semibold text-white pdf_table_border border-white"
                >
                  {item.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData?.map((item: any, index: any) => (
              <tr key={index} style={{ backgroundColor: "#EEEEEE", color: "#000000" }}>
                <td className="p-1 text-center pdf_table_border border-white">{item.policyYear}</td>
                <td className="p-1 text-center pdf_table_border border-white">{item.insuredAge}</td>
                <td className="p-1 text-center pdf_table_border border-white">
                  ${getUSANumberFormat(item.estimatedLoanPayoffOrIncome, false)}
                </td>
                <td className="p-1 text-center pdf_table_border border-white">
                  ${getUSANumberFormat(item.illustratedPlanAccumulatedValue, false)}
                </td>
                <td className="p-1 text-center pdf_table_border border-white">
                  ${getUSANumberFormat(item.illustratedPlanSurrenderValue, false)}
                </td>
                <td className="p-1 text-center pdf_table_border border-white">
                  ${getUSANumberFormat(item.illustratedPlanDB, false)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
    return (
      <div>
        <h1 className="text-center text-2xl font-bold mb-5 conthrax-font interactive-proposal-text">
          Plan Projections
        </h1>
        <div className="w-full mb-5 bg-white">
          <div className="flex justify-between conthrax-font" style={{ width: "503px" }}>
            <p className="font-bold text-gray-800 text-sm">Income</p>
            <div className="text-base font-bold text-gray-500">
              ${formatToCompactNumber(currentYearIncome)}
            </div>
          </div>
          <Chart
            type="bar"
            height="250px"
            width="503px"
            data={incomeChart}
            options={lineChartOptions(false, ipTooltipColor, "Plan Year", "Plan Year")}
          />
        </div>
        <div className="w-full mb-5 bg-white">
          <div className="flex justify-between conthrax-font" style={{ width: "503px" }}>
            <p className="font-bold text-gray-800 text-sm">Account Value</p>
            <div className="text-base font-bold text-gray-500">
              ${formatToCompactNumber(currentYearAccountValue)}
            </div>
          </div>
          <Chart
            type="line"
            height="250px"
            width="503px"
            data={accountValueChart}
            options={lineChartOptions(false, ipTooltipColor, "Plan Year", "Plan Year")}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col  h-full relative min-h-screen">
      <div className="relative z-20 px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
        {renderContent()}
      </div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{
            backgroundImage: `url(${HexagonImg})`,
            backgroundSize: "cover",
          }}
        />
        <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default SDIPProjections;
